module.exports = __webpack_public_path__ + "media/img/down-icon-ea8304da224eb7cd16125d2522497e80.svg";